<template>
	<div>
		<v-layout row wrap class="mb-5">
			<v-flex xs12>
				<h5 class="headline mb-4">Payment Details</h5>
			</v-flex>
			<v-flex xs12 md6 lg4>
				<div class="paymentDetailsCard justify-space-between verCenteredChild pos-rel">
					<div v-if="!isPaymentDetailsPresent" class="justify-space-between verCenteredChild full-width">
						<div class="addPaymentText">Add Payment Details</div>

						<v-btn fab icon @click="updatePaymentDialog = true">
							<v-icon size="40">add</v-icon>
						</v-btn>
					</div>
					<div v-else class="full-width pos-rel">
						<div class="mb-2 accountFields">
							Account Name:
							<span class="accountDetails">{{accName}}</span>
						</div>
						<div class="mb-2 accountFields">
							Account Number:
							<span class="accountDetails">{{accNo}}</span>
						</div>
						<div class="mb-2 accountFields">
							Account IFSC:
							<span class="accountDetails">{{accIfsc}}</span>
						</div>
					</div>
					<div class="top-right-align pa-0" v-if="isPaymentDetailsPresent">
						<v-tooltip right v-if="status === 'not_initiated' || status === 'failed'">
							<v-btn slot="activator" flat small color="red" @click="otpModal = true">Verify</v-btn>
							<span>Click To verify account</span>
						</v-tooltip>
						<v-tooltip right v-else-if="status === 'success'">
							<v-icon slot="activator" :color="themeInputColor" class="pa-2">check_circle</v-icon>
							<span>Verified</span>
						</v-tooltip>
					</div>
					<div
						class="edit-payment-details-btn cursor--pointer pa-1"
						@click="updatePaymentDialog = true"
						v-if="isPaymentDetailsPresent"
					>
						<v-icon size="15" class="px-1" color="blue lighten-1">edit</v-icon>Update
					</div>
				</div>
			</v-flex>
		</v-layout>

		<v-dialog v-model="updatePaymentDialog" persistent max-width="600px">
			<v-card class="pa-4">
				<v-card-title>
					<span class="headline">Add/Update Bank Details</span>
				</v-card-title>
				<v-card-text>
					<v-container grid-list-md class="pa-0">
						<v-layout wrap>
							<v-flex xs12 sm6 md5>
								<v-text-field label="Account Name*" required v-model="accName" autocomplete="off"></v-text-field>
							</v-flex>
						</v-layout>
						<v-layout>
							<v-flex xs5>
								<v-text-field
									label="Account Number*"
									required
									v-model="accNo"
									autocomplete="new_account"
									type="password"
									@paste.prevent
								></v-text-field>
							</v-flex>
							<v-flex xs5 offset-xs1>
								<v-text-field
									label="Confirm Account Number*"
									required
									:rules="[checkAccountNumberRule]"
									v-model="confirmAccNo"
									@paste.prevent
								></v-text-field>
							</v-flex>
						</v-layout>
						<v-layout>
							<v-flex xs12 sm6 md5>
								<v-text-field label="Account IFSC*" v-model="accIfsc"></v-text-field>
							</v-flex>
						</v-layout>
						<v-layout>
							<v-flex xs12 sm6 md5>
								<v-select label="AccountType*" required v-model="accType" :items="['savings', 'current']"></v-select>
							</v-flex>
						</v-layout>
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue darken-1" flat @click="updatePaymentDialog = false" outline>Cancel</v-btn>
					<v-btn
						color="blue darken-1"
						@click="updatePaymentDetails"
						class="white--text"
						:disabled="checkDisable"
						:loading="updatePaymentDetailsLoading"
					>Save</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<otp-modal
			:otpModal="otpModal"
			amount="1"
			heading="Verify OTP"
			:isLoading="verifyAccountDetailsLoading"
			:themeInputColor="themeInputColor"
			@ACTION_BUTTON_CLICKED="verifyAccountDetails"
			@CLOSE_OTP_MODAL="otpModal = false"
		/>
	</div>
</template>

<script>
import { ADD_UPDATE_PAYMENT_DETAILS } from "@/store/action-types";
import { ACCOUNT_VERIFICATION } from "@/store/action-types";

import OTPModal from "@/components/otp-modal";

export default {
	name: "UpdatePaymentDetails",
	props: [
		"themeInputColor",
		"isPaymentDetailsPresent",
		"paymentDetails",
		"userId",
		"username",
		"retailerData"
	],
	data() {
		return {
			accNo: null,
			accType: null,
			accName: null,
			accIfsc: null,
			status: null,
			verifyAccountOTP: null,
			confirmAccNo: null,
			updatePaymentDialog: false,
			updatePaymentDetailsLoading: false,
			verifyAccountDetailsLoading: false,
			checkAccountNumberRule: v =>
				(v && this.accNo && v === this.accNo) ||
				"Account number does not match!",
			otpModal: false
		};
	},
	components: {
		"otp-modal": OTPModal
	},
	mounted() {
		this.fillDefaultDetails();
	},
	computed: {
		checkDisable() {
			return (
				!this.accNo ||
				!this.accType ||
				!this.accName ||
				!this.confirmAccNo ||
				this.accNo != this.confirmAccNo
			);
		}
	},
	methods: {
		fillDefaultDetails() {
			const {
				accNo,
				accType,
				accName,
				accIfsc,
				status
			} = this.paymentDetails;
			this.accNo = accNo;
			this.accType = accType;
			this.accName = accName;
			this.accIfsc = accIfsc;
			this.status = status || "not_initiated";
			this.confirmAccNo = accNo;
		},
		updatePaymentDetails() {
			const {
				accNo,
				accIfsc,
				accName,
				accType,
				username,
				userId,
				retailerData
			} = this;
			let to_send = {
				mode: "bank",
				userId,
				accNo,
				accIfsc,
				accName,
				accType,
				username,
				userState: retailerData.state
			};

			if (!this.updatePaymentDetailsLoading) {
				this.updatePaymentDetailsLoading = true;
				this.$store
					.dispatch(ADD_UPDATE_PAYMENT_DETAILS.dispatch, to_send)
					.catch(() => {})
					.then(() => {
						this.updatePaymentDetailsLoading = false;
						this.updatePaymentDialog = false;
					});
			}
		},
		verifyAccountDetails({ otp }) {
			if (!this.verifyAccountDetailsLoading) {
				const to_send = {
					userId: this.userId,
					username: this.username,
					mode: "bank",
					otp
				};
				// console.log("to_send: ", to_send);
				// return;
				this.verifyAccountDetailsLoading = true;
				this.$store
					.dispatch(ACCOUNT_VERIFICATION.dispatch, to_send)
					.catch(() => {})
					.then(() => {
						this.verifyAccountDetailsLoading = false;
						this.otpModal = false;
					});
			}
		}
	},
	watch: {
		paymentDetails(newVal) {
			// console.log("newVal: ", newVal);
			if (newVal) {
				this.fillDefaultDetails();
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.paymentDetailsCard {
	padding: 10px;
	color: #7d7d7d;
	height: 150px;
	border-radius: 12px;
	border: 1px solid #eee;
}
.addPaymentText {
	font-size: 18px;
	padding: 10px;
}
.accountDetails {
	font-weight: 500;
	font-size: 18px;
}
.accountFields {
	font-size: 14px;
}
.edit-payment-details-btn {
	text-align: end;
	color: #2c92eb;
	position: absolute;
	right: 1%;
	bottom: 1%;
}
</style>
